<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:width="width"
		:before-close="handleClose"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
	>
		<div>
			<!-- 弹窗内容部分 -->
			<div class="flex-row-center-between">
				<label class="yx-color-text-secondary font-h4-regular">服务器地址</label>
				<div class="flex-row-align-center">
					<div style="width: 414px" class="text-align-right yx-color-text-primary font-h4-regular">
						{{ setting.serverUrl }}
					</div>
					<i class="el-icon-copy-document cursor-pointer ml-12 hover" @click="handleCopy(setting.serverUrl)"></i>
				</div>
			</div>
			<div class="flex-row-center-between mt-16">
				<label class="yx-color-text-secondary font-h4-regular">Token令牌</label>
				<div class="flex-row-align-center">
					<div style="width: 414px" class="text-align-right yx-color-text-primary font-h4-regular">{{ setting.token }}</div>
					<i class="el-icon-copy-document cursor-pointer ml-12 hover" @click="handleCopy(setting.token)"></i>
				</div>
			</div>
			<div class="flex-row-center-between mt-16">
				<label class="yx-color-text-secondary font-h4-regular">消息密钥</label>
				<div class="flex-row-align-center">
					<div style="width: 414px" class="text-align-right yx-color-text-primary font-h4-regular">{{ setting.messageKey }}</div>
					<i class="el-icon-copy-document cursor-pointer ml-12 hover" @click="handleCopy(setting.messageKey)"></i>
				</div>
			</div>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from 'lodash';
import { copy } from '@/utils/common';

export default {
	props: {},
	data() {
		return {
			title: '查看参数', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			setting: {
				token: '43F29E83B58A158F25183A3AD70B3AE8',
				messageKey: 'ODYxYzc2Y2I5ZDM4NDZjMWEwNGFlZTIxMzQ2MTM3M2E',
				serverUrl: '',
			},
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DIALOG_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},

	methods: {
		// 主动显示弹窗
		show(groupId) {
			this.setting.serverUrl = `https://api.supsaas.com/micro-product-center/wx/shp/callBack/${groupId}`;
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			// 按钮loading开启
			this.loading = true;
			try {
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 弹窗尺寸，small:400px，normal:600px，large:800px
			this.size = 'normal';
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
	components: {},
	beforeDestroy() {},
};
</script>
